import { Link } from "react-router";
import Info from "../Info/Info";
import "./table.scss";
import { ILinkModel, IMarketingResponseModel } from "../../core/models";
import { ReactNode } from "react";

export interface ITableProps {
  props: IMarketingResponseModel;
}

const Table = ({ props }: ITableProps) => {
  return (
    <section className="section-table">
      <div className="section-table__head">
        <h2>{props.title}</h2>
      </div>
      <div className="section-table__content">
        <table>
          <thead>
            <tr>
              <th>BIST Endeksleri</th>
              <th>Son</th>
              <th>Fark</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>BIST30</td>
              <td>10.000,35</td>
              <td>6,00</td>
              <td>0.10</td>
            </tr>
            <tr>
              <td>BIST30</td>
              <td>10.000,35</td>
              <td>6,00</td>
              <td>0.10</td>
            </tr>
            <tr>
              <td>BIST30</td>
              <td>10.000,35</td>
              <td>6,00</td>
              <td>0.10</td>
            </tr>
            <tr>
              <td>BIST30</td>
              <td>10.000,35</td>
              <td>6,00</td>
              <td>0.10</td>
            </tr>
            <tr>
              <td>BIST30</td>
              <td>10.000,35</td>
              <td>6,00</td>
              <td>0.10</td>
            </tr>
            <tr>
              <td>BIST30</td>
              <td>10.000,35</td>
              <td>6,00</td>
              <td>0.10</td>
            </tr>
            <tr>
              <td>BIST30</td>
              <td>10.000,35</td>
              <td>6,00</td>
              <td>0.10</td>
            </tr>
          </tbody>
        </table>
        <Info></Info>
        {props.button_items.map(
          (link: ILinkModel, index: number): ReactNode => {
            return (
              <Link
                to={{
                  pathname: link.url ?? "",
                }}
                className="btn primary"
                key={index}
              >
                {link.title}
              </Link>
            );
          }
        )}
      </div>
    </section>
  );
};

export default Table;
